import { render, staticRenderFns } from "./DetailedfulTransfer.vue?vue&type=template&id=45df3d63&scoped=true"
import script from "./DetailedfulTransfer.vue?vue&type=script&lang=js"
export * from "./DetailedfulTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45df3d63",
  null
  
)

export default component.exports